module.exports = __webpack_public_path__ + "img/MEDIA008.e60b89c4.jpg";